import { useEffect, useState } from 'react';
export const useDebounce = (val, delay = 500) => {
    const [storedValue, setValue] = useState(val);
    useEffect(() => {
        const handle = setTimeout(() => {
            setValue(val);
        }, delay);
        return () => {
            clearTimeout(handle);
        };
    }, [val, delay]);
    return storedValue;
};
